/**
 * Validação de entrada numérica para InputValue ao digitar
 */
export const handleNumericKeyDown = (
  event: React.KeyboardEvent<HTMLInputElement>,
  minValue?: number,
  maxValue?: number,
): void => {
  if (minValue === undefined && maxValue === undefined) {
    return;
  }

  const key = event.key;
  const isNumericKey = /^\d$/.test(key);
  const isControlKey = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter"].includes(key);
  const isModifierKey = event.ctrlKey || event.metaKey;

  // Permitir teclas de controle e modificadores
  if (isControlKey || isModifierKey) {
    return;
  }

  // Bloquear caracteres não-numéricos
  if (!isNumericKey) {
    event.preventDefault();
    return;
  }

  const input = event.currentTarget;
  const { value, selectionStart, selectionEnd } = input;

  // Calcula o novo valor respeitando o texto selecionado (ex.: Ctrl+A + dígito)
  const start = selectionStart ?? value.length;
  const end = selectionEnd ?? value.length;
  const newValue = `${value.slice(0, start)}${key}${value.slice(end)}`;

  if (newValue.trim() === "") {
    return;
  }

  const numValue = Number.parseInt(newValue, 10);

  if (Number.isNaN(numValue)) {
    event.preventDefault();
    return;
  }

  // Validar mínimo
  if (minValue !== undefined && numValue < minValue) {
    // Permitir se ainda está digitando o primeiro dígito (ex.: "4" antes de "40")
    if (newValue.length === 1) {
      return;
    }
  }

  // Validar máximo
  if (maxValue !== undefined && numValue > maxValue) {
    event.preventDefault();
  }
};

/**
 * Validação de entrada numérica para InputValue ao colar
 */
export const handleNumericPaste = (
  event: React.ClipboardEvent<HTMLInputElement>,
  minValue?: number,
  maxValue?: number,
): void => {
  if (minValue === undefined && maxValue === undefined) {
    return;
  }

  const pastedText = event.clipboardData.getData("text/plain");

  if (!/^\d+$/.test(pastedText)) {
    event.preventDefault();
    return;
  }

  if (pastedText !== "") {
    const numValue = Number.parseInt(pastedText, 10);

    if ((minValue !== undefined && numValue < minValue) || (maxValue !== undefined && numValue > maxValue)) {
      event.preventDefault();
    }
  }
};
